import { render } from "./CotizacionesView.vue?vue&type=template&id=3a94d234&scoped=true"
import script from "./CotizacionesView.vue?vue&type=script&lang=js"
export * from "./CotizacionesView.vue?vue&type=script&lang=js"

import "./CotizacionesView.vue?vue&type=style&index=0&id=3a94d234&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a94d234"]])

export default __exports__